export default "__VITE_ASSET__Dkc8VKTJ__"